<script lang="ts">
import { defineComponent } from "vue";

const icons: Record<string, string> = {
    djf_update_logo: "/imgs/djf_update_logo.png?url",
    djf_update_search: "/imgs/djf_update_search.png?url",
    djf_update_company: "/imgs/djf_update_company.png?url",
    djf_update_mail: "/imgs/djf_update_mail.png?url",
    djf_update_phone: "/imgs/djf_update_phone.png?url",
    djf_update_web: "/imgs/djf_update_web.png?url",
    djf_update_star: "/imgs/djf_update_star.png?url",
};

export default defineComponent({
    name: "IconVue",
    components: {},
    props: {
        identifier: {
            type: String,
            default: "djf_search",
        },
        searching: {
            type: Boolean,
            default: false,
        },
    },
    emits: [],
    data: () => ({}),
    computed: {
        url(): string | null {
            return icons[this.identifier] ?? null;
        },
    },
    methods: {},
});
</script>

<template>
    <div v-if="identifier" class="icon" :class="{ 'searching-icon': searching }">
        <div v-if="identifier.includes('arrow')" class="custom-icon flex flex--width flex--height flex--valign-c flex--halign-c">
            <span class="text text--size-72 text--color-white text--bold text--shadow">
                {{ identifier === "arrow_left" ? "<" : ">" }}
            </span>
        </div>

        <svg-vue v-else-if="identifier === 'djf_search'" :icon="identifier"></svg-vue>

        <img v-else-if="url" class="icon-img" :src="url" />
    </div>
</template>

<style lang="scss" scoped>
.icon {
    width: 100%;
    height: 100%;
    position: relative;

    .icon-img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
    }
}
</style>
